export const COOKIES_BAR_MESSAGE =
  "We use cookies to offer you a better browsing experience, analyze site traffic, personalize content, and serve targeted advertisements." +
  " If you continue to use this site, you consent to our use of cookies." +
  " You can disable the usage of cookies by changing the settings of your browser.";



// WEBPACK FOOTER //
// ./src/constants/messages.js